import { Piatto } from "../interfaces/piatto";
import { Ristorante } from "../mapper/Ristorante";
import { db } from "../script/Fetch";
import FirestoreDbQueries from "./FirestoreDbQueries";

export default class RistoranteDbQueries extends FirestoreDbQueries<Ristorante> {
    listener?: () => void;
    ri: { [key: string]: Piatto; } = {};

    startListenRistorante(ristoranteId: string) {
        this.listener = db.collection("ristoranti")
            .doc(ristoranteId)
            .onSnapshot(async (change) => {
                let ristorante = this.convertFromFirestore(change.id, change.data());
                this.notify(ristorante);
            });
    }

    stopListenRistorante() {
        if (this.listener === undefined) {
            return;
        }
        this.listener();
    }


    notify(ristorante: Ristorante): void {
        this.instances.forEach(instance => {
            instance.updateRistorante(ristorante);
        });
    }
    
    convertFromFirestore(documentId: string, mapperObject: any): Ristorante {
        return Ristorante.convertFromFirestore(documentId, mapperObject);
    }

    async selectById(id: string) {
        let snapshot =  await db.collection("ristoranti").doc(id).get();
        return this.convertFromFirestore(snapshot.id, snapshot.data());
    }

    selectTavoliByRistoranteId(ristoranteId: string) {
        return db.collection("ristoranti").doc(ristoranteId).collection("tavoli").get();
    }
}